
































import { defineComponent, ref } from '@vue/composition-api';
import { trackEvent } from '@tt4b/ttam-utils';

const name = 'ttam-auto-save-empty-campaign-dialog';

export default defineComponent({
  name,
  props: {
    visible: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const isNotShowAnymore = ref(false);

    const handleGotIt = () => {
      emit('exit', isNotShowAnymore.value);
      emit('close');
    };

    const handleCancel = () => {
      trackEvent('ttam_creation_draft_exit_without_draft_cancel');
      emit('close');
    };

    return {
      name,
      isNotShowAnymore,
      handleGotIt,
      handleCancel,
    };
  },
});
